export default class IntegrationService {
  constructor(axiosIns, serviceConfig) {
    this.axiosIns = axiosIns;
    this.serviceConfig = serviceConfig;
  }

  connectCoupangVendor(payload) {
    return this.axiosIns.put('/api/v1/coupang/vendor', payload);
  }

  getCoupangVendor() {
    return this.axiosIns.get('/api/v1/coupang/vendor');
  }

  toggleVendorStatus(isEnabled) {
    return this.axiosIns.put('/api/v1/coupang/vendor/status', {
      is_enabled: isEnabled
    });
  }

  getCoupangOrders(params) {
    return this.axiosIns.get('/api/v1/coupang/orders', { params });
  }

  getCoupangOrderConsignmentData(orderId, params = {}) {
    return this.axiosIns.get(`/api/v1/coupang/orders/${orderId}`, { params });
  }
}
